import axios from "axios";
import { environment } from "../config.env";

const ENDPOINT_DOMAIN = process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || "";

const domain = ENDPOINT_DOMAIN;

// export function getUserDataList(page) {
//   return new Promise((resolve) => {
//     let url = `${domain}/api/v1/laboratory/admin/manage/user/getUserDataList?role=LABORATORY_PERSONNEL&page=${page}&number_per_page=10`;
//     let header = {
//       "Content-Type": "application/json",
//       Authorization: localStorage.getItem("pg_access_token"),
//     };
//     axios
//       .get(url, { headers: header })
//       .then((res) => {
//         resolve(res);
//       })
//       .catch(() => {
//         resolve(false);
//       });
//   });
// }

export function getUserDataList(page) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/admin/manage/user/getUserDataList`;
    let body = {
      role: "LABORATORY_PERSONNEL",
      page: page,
      number_per_page: "10"
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}


// export function getLaboratoryMember() {
//   return new Promise((resolve) => {
//     let url = `${domain}/api/v1/laboratory/member/getMember`;
//     let header = {
//       "Content-Type": "application/json",
//       Authorization: localStorage.getItem("pg_access_token"),
//     };
//     axios
//       .get(url, { headers: header })
//       .then((res) => {
//         resolve(res);
//       })
//       .catch(() => {
//         resolve(false);
//       });
//   });
// }

export function getLaboratoryMember() {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/member/getMember`;
    let body = {};
    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function setApprove(uid, approve) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/admin/manage/user/setApprove`;
    let body = {
      uid: uid,
      approve: approve,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function setEnable(uid, enable) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/admin/manage/user/setEnable`;
    let body = {
      uid: uid,
      enable: enable,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

//นำเข้าข้อมูลการตรวจแลป
export function getImportLab() {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/import/getImportLab`;
    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function importFile(formData) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/lab/import`;
    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, formData, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}
export function importLab(formData) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/import/importLab`;
    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, formData, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removeLab(lab_id) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/import/removeLab`;
    let body = {
      lab_id: lab_id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function inputLab(body) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/import/inputLab`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

//ตรวจสอบประวัติการลงผลแลป
export function getDateHistory() {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/lab/getDateHistory`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getLabHistory(date, pid) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/lab/getLabHistory`;

    let startDate = null;
    let endDate = null;

    if (Array.isArray(date)) {
        startDate = date[0];
        endDate = date[1];
    } else {
        startDate = date;
        endDate = date; // กรณีเลือกวันเดียว ให้ start กับ end เท่ากัน
    }

    let body = {
      startDate: startDate,
      endDate: endDate,
      pid: pid,
    };

    // let body = {
    //   date: date,
    //   pid: pid,
    // };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function getGuideline(page, numberPerPage, filter) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/guideline/getGuideline`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    }

    if(filter?.title) params.title = filter.title;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { headers: header, params })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}
export function getDocument(page, numberPerPage, filter) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/document/getDocument`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    }

    if(filter?.document_name) params.document_name = filter.document_name;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { headers: header, params })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function postLaboratoryPersonnel(body) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/admin/manage/register/laboratoryPersonnel`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function getLabClassifyList() {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/labclassify/getLabClassifyList`;
    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getTransferAccount() {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/admin/manage/user/getTransferAccount`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function actionTransferAccount(transfer_id, status) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/admin/manage/user/actionTransferAccount`;
    let body = {
      transfer_id: transfer_id,
      status: status,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function transferAccount(laboratory_id, user_data) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/member/transferAccount`;
    let body = {
      laboratory_id: laboratory_id,
      user_data: user_data
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function transferAdminRole(uid) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/laboratory/admin/manage/user/transferAdminRole`;
    let body = {
      uid: uid,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removeDocument(documentId) {
  return new Promise((resolve) => {
    const path = "/api/v1/laboratory/document/removeDocument";
    let body = {
      document_id: documentId,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function addDocument(formDataBody) {
  return new Promise((resolve) => {
    let url = `/api/v1/laboratory/document/addDocument`;
    let header = {
      "Content-Type": "multipart/form-data",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, formDataBody, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function addGuideline(
  titleValue,
  title,
  detail,
  pin,
  active,
  publishStartDate,
  publishEndDate
) {
  return new Promise((resolve) => {
    let url = `/api/v1/laboratory/guideline/addGuideLine`;
    let body = {
      type: titleValue,
      title: title,
      detail: detail,
      active: active,
      pin: pin,
      publish_start_date: publishStartDate,
      publish_end_date: publishEndDate,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}


export function updateGuideline(
  guideline_id,
  titleValue,
  title,
  detail,
  pined,
  active,
  publishStartDate,
  publishEndDate
) {
  return new Promise((resolve) => {
      let url = `/api/v1/laboratory/guideline/updateGuideline`;
      let body = {
          guideline_id: guideline_id,
          type: titleValue,
          title: title,
          detail: detail,
          active: active,
          pined: pined,
          publish_start_date: publishStartDate,
          publish_end_date: publishEndDate,
      };
      let header = {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("pg_access_token"),
      };
      axios
          .post(url, body, { headers: header })
          .then((res) => {
              resolve(res);
          })
          .catch(() => {
              resolve(false);
          });
  });
}


export function removeGuideline(guidelineId) {
  return new Promise((resolve) => {
    let url = `/api/v1/laboratory/guideline/removeGuideline`;
    let body = {
      guideline_id: guidelineId,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}



export function getGuideLineDetail(id) {
  return new Promise((resolve) => {
    let url = `/api/v1/laboratory/guideline/getGuideLineDetail`;
    let body = {
      id: id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}